<template>
  <div class="default-filter" v-if="showFilters">
    <div class="button-container">
      <ButtonComponent
        v-permission="permissions.filterEdit"
        @click="saveFilter()"
        mod="gradient-bg"
        class="button-redesign--mpk-commissions"
      >
        Сохранить фильтр
      </ButtonComponent>
      <ButtonComponent
        v-permission="permissions.filterView"
        @click="loadFilter()"
        mod="gradient-bg"
        class="button-redesign--mpk-commissions"
      >
        Загрузить фильтр
      </ButtonComponent>
    </div>

    <ModalComponent title="Выберите роль" @close="dialogRole = false" v-model="dialogRole">
      <div class="form__body">
        <div class="form__body-inputBlock form__body-inputBlock--spaced">
          <p>Роль</p>
          <ComponentInput
            placeholder="Укажите роль"
            :select2Settings="select2SettingsNoClear"
            :select2Options="roles"
            v-model="roleId"
            type="select2"
          />
        </div>
        <div class="form__body-inputBlock form__body-inputBlock--buttons">
          <ButtonComponent mod="gradient-bg" @click="selectUserRole"> Выбрать </ButtonComponent>
          <ButtonComponent mod="border" @click="dialogRole = false"> Закрыть </ButtonComponent>
        </div>
      </div>
    </ModalComponent>
  </div>
</template>

<script>
  import ComponentInput from '@/common/components/ComponentInput.vue';
  import ButtonComponent from '@/common/components/redesigned/ButtonComponent.vue';
  import Constants from '@/common/constants';
  import { getFilterValue, updateFilterValue } from '@/common/utils/filterManager';

  import ModalComponent from '@/components/modals/ModalComponent.vue';

  import Api_Roles from '@/modules/admin/api/roles';

  const PERMISSIONS = {
    filterView: Constants.Permissions.FilterView,
    filterEdit: Constants.Permissions.FilterEdit,
  };

  export default {
    name: 'DefaultFilter',
    components: { ModalComponent, ComponentInput, ButtonComponent },
    emits: ['loadFilter'],
    props: {
      filterValue: {
        type: Object,
        default: null,
      },
    },
    data() {
      return {
        filter: {},
        roles: [],
        dialogRole: false,
        isSaving: false,
        roleId: 1,
        select2SettingsNoClear: {
          language: Constants.langRu,
          allowClear: false,
        },
        showFilters: false,
      };
    },
    computed: {
      permissions() {
        return PERMISSIONS;
      },
    },
    created() {
      if (this.filterValue) this.filter = this.filterValue;
      this.showFilters = this.$store.state.auth?.oidc?.profile?.showFilters;
      if (this.showFilters) {
        this.loadDictionaries();
      }
    },
    methods: {
      saveFilter() {
        this.isSaving = true;
        this.dialogRole = true;
      },
      loadFilter() {
        this.isSaving = false;
        this.dialogRole = true;
      },
      loadDictionaries() {
        Api_Roles.search({ pageNumber: 1, pageSize: 0 }).then((response) => {
          this.roles = response.data.items.map((x) => ({ id: x.id, text: x.title }));
        });
      },
      selectUserRole() {
        this.dialogRole = false;

        if (this.isSaving) {
          let currentFilterItem = {
            roleId: this.roleId,
            route: this.$route.path,
            value: JSON.stringify(this.filter),
          };

          updateFilterValue(currentFilterItem)
            .then(() => {
              Constants.alert.fire('Редактирование фильтра', `Фильтр успешно сохранен`, 'success');
            })
            .catch(() => {
              Constants.alert.fire('Сохранение фильтра', Constants.commonError, 'error');
            });
        } else {
          getFilterValue(this.roleId, this.$route.path, false).then((response) => {
            let currentFilter = response.data;
            if (currentFilter) this.$emit('loadFilter', JSON.parse(currentFilter.value));
            else Constants.alert.fire('Загрузка фильтра', 'Фильтр для этой роли не найден', 'error');
          });
        }
      },
    },
    watch: {
      filterValue: {
        handler: function (val) {
          if (val) this.filter = val;
          else this.filter = {};
        },
        deep: true,
      },
    },
  };
</script>

<style lang="scss" scoped>
  .button-container {
    display: flex;
    flex-wrap: wrap;
  }
  .default-filter {
    @media (max-width: $mobile) {
      width: 100%;
    }
  }
  .form__body-inputBlock--spaced {
    margin-bottom: 16px;
    padding-bottom: 16px;
  }
  .form__body-inputBlock--buttons {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
  }
</style>
